module.exports = __webpack_public_path__ + "static/media/red-bull@2x.3f3a399a.png";